module.exports = __webpack_public_path__ + "img/custom4.5104cb72.png";